import { Injectable, Type } from '@angular/core';
import { CellType } from '../models/view-builder.models';
import { BaseCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/base-cell.component';
import { TextCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/text-cell/text-cell.component';
import { FilterListCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/filter-list-cell/filter-list-cell.component';
import { MultiSelectCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/multi-select-cell/multi-select-cell.component';
import { ListDisplayCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/list-display-cell/list-display-cell.component';
import { InputFieldCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/input-field-cell/input-field-cell.component';
import { CheckboxCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/checkbox-cell/checkbox-cell.component';
import { ActionCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/action-cell/action-cell.component';
import { DataDisplayCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/data-display-cell/data-display-cell.component';
import { NoteBlockCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/note-block-cell/note-block-cell.component';
import { RadialButtonCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/radial-button-cell/radial-button-cell.component';
import { DatetimePickerCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/datetime-picker-cell/datetime-picker-cell.component';
import { ImageCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/image-cell/image-cell.component';
import { DataEntryCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/data-entry-cell/data-entry-cell.component';
import { LookupCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/lookup-cell/lookup-cell.component';
// PDF Cell Components
import { PdfTextCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-text-cell/pdf-text-cell.component';
import { PdfImageCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-image-cell/pdf-image-cell.component';
import { PdfFieldCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-field-cell/pdf-field-cell.component';
import { PdfTableCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-table-cell/pdf-table-cell.component';
import { PdfPageBreakCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-page-break-cell/pdf-page-break-cell.component';
import { PdfDatetimeCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-datetime-cell/pdf-datetime-cell.component';
import { PdfRowCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-row-cell/pdf-row-cell.component';
import { CalculationCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/calculation-cell/calculation-cell.component';
import { PdfListCalcCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-list-calc-cell/pdf-list-calc-cell.component';
import { PdfGridCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-grid-cell/pdf-grid-cell.component';
import { PdfCheckboxCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-checkbox-cell/pdf-checkbox-cell.component';
import { PdfLineCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/pdf-line-cell/pdf-line-cell.component';
import { ListCalcCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/list-calc-cell/list-calc-cell.component';
import { DataEntryTableCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/data-entry-table-cell/data-entry-table-cell.component';
import { FileReferenceCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/file-reference-cell/file-reference-cell.component';
import { EmailComposeCellComponent } from 'src/app/common/bhub-common-module/components/view-cells/email-compose-cell/email-compose-cell.component';

@Injectable({
  providedIn: 'root'
})
export class CellFactoryService {
  private cellComponents: Map<CellType, Type<BaseCellComponent>> = new Map();

  constructor() {
    this.registerCellComponents();
  }

  private registerCellComponents(): void {
    this.cellComponents.set(CellType.TEXT, TextCellComponent);
    this.cellComponents.set(CellType.FILTER_LIST, FilterListCellComponent);
    this.cellComponents.set(CellType.MULTI_SELECT, MultiSelectCellComponent);
    this.cellComponents.set(CellType.LIST_DISPLAY, ListDisplayCellComponent);
    this.cellComponents.set(CellType.INPUT, InputFieldCellComponent);
    this.cellComponents.set(CellType.CHECKBOX, CheckboxCellComponent);
    this.cellComponents.set(CellType.ACTION, ActionCellComponent);
    this.cellComponents.set(CellType.DATA_DISPLAY, DataDisplayCellComponent);
    this.cellComponents.set(CellType.NOTE_BLOCK, NoteBlockCellComponent);
    this.cellComponents.set(CellType.RADIAL_BUTTON, RadialButtonCellComponent);
    this.cellComponents.set(CellType.DATETIME_PICKER, DatetimePickerCellComponent);
    this.cellComponents.set(CellType.IMAGE, ImageCellComponent);
    this.cellComponents.set(CellType.DATA_ENTRY, DataEntryCellComponent);
    this.cellComponents.set(CellType.LOOKUP, LookupCellComponent);
    this.cellComponents.set(CellType.EMAIL_COMPOSE, EmailComposeCellComponent);
    this.cellComponents.set(CellType.CALCULATION, CalculationCellComponent);
    this.cellComponents.set(CellType.LIST_CALC, ListCalcCellComponent);
    this.cellComponents.set(CellType.DATA_ENTRY_TABLE, DataEntryTableCellComponent);
    this.cellComponents.set(CellType.FILE_REFERENCE, FileReferenceCellComponent);
    // PDF Cell Components
    this.cellComponents.set(CellType.PDF_TEXT, PdfTextCellComponent);
    this.cellComponents.set(CellType.PDF_IMAGE, PdfImageCellComponent);
    this.cellComponents.set(CellType.PDF_FIELD, PdfFieldCellComponent);
    this.cellComponents.set(CellType.PDF_TABLE, PdfTableCellComponent);
    this.cellComponents.set(CellType.PDF_PAGE_BREAK, PdfPageBreakCellComponent);
    this.cellComponents.set(CellType.PDF_DATETIME, PdfDatetimeCellComponent);
    this.cellComponents.set(CellType.PDF_ROW, PdfRowCellComponent);
    this.cellComponents.set(CellType.PDF_LIST_CALC, PdfListCalcCellComponent);
    this.cellComponents.set(CellType.PDF_GRID, PdfGridCellComponent);
    this.cellComponents.set(CellType.PDF_CHECKBOX, PdfCheckboxCellComponent);
    this.cellComponents.set(CellType.PDF_LINE, PdfLineCellComponent);
  }

  getCellComponent(cellType: CellType): Type<BaseCellComponent> | null {
    return this.cellComponents.get(cellType) || null;
  }

  getAllCellTypes(): CellType[] {
    return Array.from(this.cellComponents.keys());
  }

  registerCellComponent(cellType: CellType, component: Type<BaseCellComponent>): void {
    this.cellComponents.set(cellType, component);
  }
}
